import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../../Mensaje';
import Cargando from '../../../../../../Cargando';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import CryptoJS from 'crypto-js';
import { FaEdit, FaTrash, FaPlus, FaSearch } from 'react-icons/fa';

export const RW_Config_RazonesSociales = () => {
    require('../../../Remotework.css?v=1.1.0');
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando();
    const {
        ObtenerEstaciones,
        ObtenerRazonesSociales,
        CrearRazonSocial,
        ActualizarRazonSocial,
        EliminarRazonSocial,
        ObtenerDatosDeCuitArca
    } = PuenteApi();

    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});
    const [razonesPorEstacion, setRazonesPorEstacion] = useState({});

    // Modal state
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('add'); // 'add' or 'edit'
    const [selectedEstacion, setSelectedEstacion] = useState(null);
    const [currentRazon, setCurrentRazon] = useState({
        id: null,
        cuit: '',
        razon_social: '',
        descripcion: '',
        domicilio: '',
        provincia: '',
        localidad: '',
        cp: '',
        telefono: '',
        condicion_iva: 'Responsable Inscripto',
        exento: false,
        iva: false,
        testing: false,
        otros: false,
    });

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerRazonesDeTodas(parsed);
        } else {
            cargarEstaciones();
        }
    }, []);

    const cargarEstaciones = async () => {
        try {
            setLoading(true);
            const response = await ObtenerEstaciones();
            if (response) {
                setEstaciones(response);
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
                await obtenerRazonesDeTodas(response);
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
            setLoading(false);
        }
    };

    const obtenerRazonesDeTodas = async (listaEstaciones) => {
        const resultados = {};
        for (const estacion of listaEstaciones) {
            try {
                const response = await ObtenerRazonesSociales(estacion.endpoint);
                resultados[estacion.id] = response || [];
            } catch (error) {
                console.error(`Error obteniendo razones de ${estacion.nombre}:`, error);
                resultados[estacion.id] = [];
            }
        }
        setRazonesPorEstacion(resultados);
        setLoading(false);
    };

    const handleToggle = (id) => {
        setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleOpenModal = (mode, estacion, razon = null) => {
        setModalMode(mode);
        setSelectedEstacion(estacion);
        if (mode === 'edit' && razon) {
            setCurrentRazon(razon);
        } else {
            setCurrentRazon({
                id: null,
                cuit: '',
                razon_social: '',
                descripcion: '',
                domicilio: '',
                provincia: '',
                localidad: '',
                cp: '',
                telefono: '',
                condicion_iva: 'Responsable Inscripto',
                exento: false,
                iva: false,
                testing: false,
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentRazon({
            id: null,
            cuit: '',
            razon_social: '',
            descripcion: '',
            domicilio: '',
            provincia: '',
            localidad: '',
            cp: '',
            telefono: '',
            condicion_iva: 'Responsable Inscripto',
            exento: false,
            iva: false,
            testing: false,
        });
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setCurrentRazon(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const buscarEnArca = async () => {
        if (!currentRazon.cuit || currentRazon.cuit.length < 11) {
            SetMensaje("Advertencia", "Ingrese un CUIT válido (11 dígitos)", 3000);
            return;
        }

        try {
            StartCargando("Buscando datos en ARCA...");
            const response = await ObtenerDatosDeCuitArca(currentRazon.cuit);
            StopCargando();

            if (response && response.success) {
                const data = response.data;
                setCurrentRazon(prev => ({
                    ...prev,
                    razon_social: data.razon_social || '',
                    domicilio: data.domicilio || '',
                    localidad: data.localidad || '',
                    provincia: data.provincia || '',
                    cp: data.cp || '',
                    condicion_iva: data.condicion_iva || prev.condicion_iva
                }));
                SetMensaje("Éxito", "Datos recuperados de ARCA", 2000);
            } else {
                SetMensaje("Error", "No se encontraron datos para el CUIT ingresado", 3000);
            }
        } catch (error) {
            StopCargando();
            console.error("Error al buscar en ARCA:", error);
            SetMensaje("Error", "Error al conectar con ARCA", 3000);
        }
    };

    const handleSave = async () => {
        if (!currentRazon.cuit || !currentRazon.razon_social || !currentRazon.domicilio) {
            SetMensaje("Error", "Complete los campos obligatorios (CUIT, Razón Social, Domicilio)", 3000);
            return;
        }

        try {
            StartCargando(modalMode === 'add' ? "Creando Razón Social..." : "Actualizando Razón Social...");
            let success = false;
            if (modalMode === 'add') {
                success = await CrearRazonSocial(selectedEstacion.endpoint, currentRazon);
            } else {
                success = await ActualizarRazonSocial(selectedEstacion.endpoint, currentRazon.id, currentRazon);
            }
            StopCargando();

            if (success) {
                Swal.fire({
                    icon: 'success',
                    title: modalMode === 'add' ? 'Creado exitosamente' : 'Actualizado exitosamente',
                    showConfirmButton: false,
                    timer: 1500
                });
                handleCloseModal();
                obtenerRazonesDeTodas(estaciones);
            }
        } catch (error) {
            StopCargando();
            console.error("Error al guardar:", error);
        }
    };

    const handleDelete = (estacion, id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "¡Esta acción no se puede deshacer!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    StartCargando("Eliminando...");
                    const success = await EliminarRazonSocial(estacion.endpoint, id);
                    StopCargando();
                    if (success) {
                        Swal.fire('Eliminado', 'La razón social ha sido eliminada.', 'success');
                        obtenerRazonesDeTodas(estaciones);
                    }
                } catch (error) {
                    StopCargando();
                    console.error("Error al eliminar:", error);
                }
            }
        });
    };


    return (
        <div className="container-fluid py-4">
            {loading ? (
                "Cargando..."
            ) : (
                <div>
                    <div className="row mb-3 align-items-center">
                        <div className="col">
                            <h2 className="mb-0">Razones Sociales</h2>
                        </div>
                    </div>

                    {estaciones.map((estacion) => (
                        <div key={estacion.id} className="mb-3">
                            <div
                                onClick={() => handleToggle(estacion.id)}
                                className="d-flex justify-content-between align-items-center p-3 border rounded cursor-pointer"
                                style={{
                                    backgroundColor: '#f5f5f5',
                                    borderColor: '#ddd',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <span>{estacion.nombre}</span>
                                    <span className="badge bg-secondary ms-3" style={{ fontSize: '12px' }}>
                                        {razonesPorEstacion[estacion.id]?.length || 0}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="me-3"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenModal('add', estacion);
                                        }}
                                    >
                                        <FaPlus className="me-1" /> Agregar
                                    </Button>
                                    <span>{expanded[estacion.id] ? '▲' : '▼'}</span>
                                </div>
                            </div>

                            {/* Contenido de la estación expandida */}
                            {expanded[estacion.id] && (
                                <div className="p-3 border mt-2" style={{ backgroundColor: '#fafafa' }}>
                                    {razonesPorEstacion[estacion.id] ? (
                                        razonesPorEstacion[estacion.id].length > 0 ? (
                                            <div className="row row-cols-1 row-cols-md-3 g-4">
                                                {razonesPorEstacion[estacion.id].map(razon => (
                                                    <div className="col" key={razon.id}>
                                                        <div className="card shadow-sm h-100" style={{ borderRadius: '10px' }}>
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                                    <h5 className="card-title mb-0">{razon.razon_social}</h5>
                                                                    <div className="d-flex flex-column gap-1 align-items-end">
                                                                        <span className="badge bg-info text-dark" style={{ fontSize: '10px' }}>{razon.cuit}</span>
                                                                        {razon.testing && (
                                                                            <span className="badge bg-warning text-dark" style={{ fontSize: '10px' }}>
                                                                                TESTING
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <p className="card-text text-muted small" style={{ marginBottom: '8px' }}>
                                                                    {razon.descripcion || 'Sin descripción'}
                                                                </p>
                                                                <div className="text-muted small mb-3">
                                                                    <div><i className="fa fa-map-marker-alt me-1"></i> {razon.domicilio}</div>
                                                                    <div>{razon.localidad}, {razon.provincia}</div>
                                                                </div>
                                                                <div className="d-flex mt-2">
                                                                    <Button
                                                                        style={{ marginRight: '10px' }}
                                                                        variant="warning"
                                                                        size="sm"
                                                                        onClick={() => handleOpenModal('edit', estacion, razon)}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleDelete(estacion, razon.id)}
                                                                    >
                                                                        Eliminar
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-center py-3 text-muted">
                                                No hay razones sociales registradas.
                                            </p>
                                        )
                                    ) : (
                                        <p>Cargando datos...</p>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* Create/Edit Modal */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{modalMode === 'add' ? 'Nueva Razón Social' : 'Editar Razón Social'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="row g-3">
                            <div className="col-md-5">
                                <Form.Group>
                                    <Form.Label className="fw-bold">CUIT <span className="text-danger">*</span></Form.Label>
                                    <div className="d-flex gap-2">
                                        <Form.Control
                                            name="cuit"
                                            className="shadow-none border-1"
                                            value={currentRazon.cuit}
                                            onChange={handleInputChange}
                                            placeholder="Sin guiones"
                                            maxLength="11"
                                            required
                                        />
                                        <Button variant="outline-primary" onClick={buscarEnArca} title="Validar en AFIP/ARCA">
                                            <FaSearch />
                                        </Button>
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-md-7">
                                <Form.Group>
                                    <Form.Label className="fw-bold">Razón Social <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        name="razon_social"
                                        value={currentRazon.razon_social}
                                        onChange={handleInputChange}
                                        placeholder="Ingrese el nombre legal"
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-12">
                                <Form.Group>
                                    <Form.Label>Descripción o Nombre Fantasía</Form.Label>
                                    <Form.Control
                                        name="descripcion"
                                        value={currentRazon.descripcion}
                                        onChange={handleInputChange}
                                        placeholder="Opcional"
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-8">
                                <Form.Group>
                                    <Form.Label className="fw-bold">Domicilio <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        name="domicilio"
                                        value={currentRazon.domicilio}
                                        onChange={handleInputChange}
                                        placeholder="Calle y número"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-4">
                                <Form.Group>
                                    <Form.Label className="fw-bold">Provincia <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        name="provincia"
                                        value={currentRazon.provincia}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="fw-bold">Localidad <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        name="localidad"
                                        value={currentRazon.localidad}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-3">
                                <Form.Group>
                                    <Form.Label className="fw-bold">C.P. <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        name="cp"
                                        value={currentRazon.cp}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-3">
                                <Form.Group>
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control
                                        name="telefono"
                                        value={currentRazon.telefono}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="fw-bold">Condición IVA <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        name="condicion_iva"
                                        value={currentRazon.condicion_iva}
                                        onChange={handleInputChange}
                                    >
                                        <option value="Responsable Inscripto">Responsable Inscripto</option>
                                        <option value="Monotributista">Monotributista</option>
                                        <option value="Exento">Exento</option>
                                        <option value="Consumidor Final">Consumidor Final</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            <div className="col-12 mt-4">
                                <h6 className="border-bottom pb-2 mb-3">Opciones Adicionales</h6>
                                <div className="d-flex flex-wrap gap-4">
                                    <Form.Check
                                        type="checkbox"
                                        id="exento"
                                        name="exento"
                                        label="Exento"
                                        checked={currentRazon.exento}
                                        onChange={handleInputChange}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        id="iva"
                                        name="iva"
                                        label="IVA"
                                        checked={currentRazon.iva}
                                        onChange={handleInputChange}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        id="testing"
                                        name="testing"
                                        label="Modo Testing"
                                        checked={currentRazon.testing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSave}>
                        {modalMode === 'add' ? 'Crear' : 'Guardar Cambios'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <style>{`
                .cursor-pointer { cursor: pointer; }
                .card:hover { transform: translateY(-3px); transition: all 0.2s ease-in-out; }
            `}</style>
        </div>
    );
};
